export const LTL_CONFIG = (lang) => {
	if (lang === 'de') {
		return 'Indywidualny plan nauki niemieckiego';
	}

	if (lang === 'es') {
		return 'Indywidualny plan nauki hiszpańskiego';
	}

	if (lang === 'it') {
		return 'Indywidualny plan nauki wtłoskiego';
	}

	if (lang === 'fr') {
		return 'Indywidualny plan nauki francuskiego';
	}

	return 'Indywidualny plan nauki angielskiego';
};
